var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-justify"},[_vm._v("\n    "+_vm._s(_vm.$t('card_content'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }